import React from 'react';
import { NREMTAssessmentList } from '../components/nremtBuilder';

const NREMTDashboard = () => {
  return <NREMTAssessmentList />;
};

export default NREMTDashboard;
